import styles from './CommonFooter.module.css';

export default function CommonFooter ({ children }) {
  return <section className={styles.top_banner}>
    {children}
  </section>
}